module.exports = __webpack_public_path__ + "static/img/questionCSel.056a3dd5.png";